//#region import libraries
import React from "react";
// custom components
import { Title, NewScreen } from "_atoms";
// scenes
import BookingAnalytics from "_scenes/portal/analytics/booking-analytics";
//#endregion

const BookingList = (props) => {
  return (
    <NewScreen>
      {/* Title Bar */}
      <Title
        subtitle="Booking Analytics"
        description={
          "View information on actual prm counts and forecasted prm bookings"
        }
      />

      {/* Analytics */}
      <BookingAnalytics />
    </NewScreen>
  );
};

export default BookingList;
